/**
 * PubSub allows for publishing and subscribing events.
 * This only exists because we can't use Events in IE11 because
 *  that fires off the mutation observer instead of being normal like
 *  the other browsers.
 */

const subscribers = {};

/**
 * Publishes the event
 *
 * @param {String} event - the event name
 * @param {Object} data - the data to pass to the subsciber
 */
const publish = (event, data = null) => {
  if (!subscribers[event]) return;

  subscribers[event].forEach((subscriberCallback) => subscriberCallback(data));
};

/**
 * Subscribes to the event
 *
 * @param {String} event - the event name
 * @param {Function} callback - the callback function
 */
const subscribe = (event, callback) => {
  if (!subscribers[event]) {
    subscribers[event] = [];
  }
  subscribers[event].push(callback);
};

export { publish, subscribe };
